<script>
	import Breadcrumb from '../../components/Breadcrumb.svelte';
	import BlogList from '../../components/BlogList.svelte';
	import OurAdvantages from '../(components)/OurAdvantages.svelte';

	export let breadcrumbs = [
		{
			name: 'Blog',
			link: '/blog'
		}
	];

	export let data;
</script>

<svelte:head>
	<title>Blog Scootland - zajímavosti, návody, aktuality</title>
	<meta name="keywords" content="blog, aktuality, články, obsah, restřík, cestování, zajímavosti, novinky"/>
	<meta name="description" content="Objevte zajímavosti a novinky ze světa skútrů i naší firmy. Sledujte náš blog, kde se neustále něco děje a sdílíme ty nejlepší příběhy!"/>
	<link rel="canonical" href={'https://www.scootland.cz/blog/'} />
	<meta property="og:title" content="Blog Scootland - zajímavosti, návody, aktuality" />
	<meta property="og:description" content="Objevte zajímavosti a novinky ze světa skútrů i naší firmy. Sledujte náš blog, kde se neustále něco děje a sdílíme ty nejlepší příběhy!"/>
	<meta property="og:image" content="/image/og-blog.webp"/>
	<meta property="og:url" content="https://www.scootland.cz/blog/"/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
</svelte:head>

<Breadcrumb {breadcrumbs} />

<section class="container mx-auto mt-10 px-2.5 md:px-0">
	<h1 class="font-heading mb-3 text-center text-2xl font-bold sm:text-3xl">Blog: Novinky ze světa skútrů</h1>

	<p class="mx-auto w-full max-w-3xl text-center text-base leading-normal">
		Objevte zajímavosti a novinky ze světa skútrů i naší firmy. Na této stránce sdílíme vše co nás cvrkne do nosu.
	</p>
</section>

<BlogList currentCategory={data?.categoryParamQuery} blog={data?.blog} class="bg-white" />

<OurAdvantages class="bg-gray-alabaster" />
